<template>
  <li role="presentation">
    <hr
      aria-orientation="horizontal"
      class="dropdown-divider"
    >
  </li>
</template>

<script>
export default {
  name: 'BDropDownDivider'
}
</script>
